var l = /* @__PURE__ */ ((r) => (r.STREET_ADDRESS = "street_address", r.COUNTRY = "country", r.ROUTE = "route", r.LOCALITY = "locality", r.POSTAL_CODE = "postal_code", r.STREET_NUMBER = "street_number", r.REGION = "administrative_area_level_1", r))(l || {});
const E = (r) => r.reduce(
  (t, a) => {
    const _ = a.types.find(
      (u) => Object.values(l).includes(
        u
      )
    );
    return _ ? {
      ...t,
      [_]: a.long_name || ""
    } : t;
  },
  {}
);
export {
  l as AddressComponentType,
  E as normaliseAddress
};
